import { Component, OnInit } from '@angular/core';
import { MatDialog,MatDialogConfig } from '@angular/material/dialog';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { NoticesDialogComponent } from './notices-dialog/notices-dialog.component';
import { LogoutDialogComponent } from '../logout-dialog/logout-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  /*
  This property is to hold current user details
  */
  userProfile: User;

  constructor(private userService: UserService, private mdDialog: MatDialog) {}

  ngOnInit(): void {
    this.userService.getCurrentUser();
    this.userService.user$.subscribe((user) => {
      this.userProfile = user;
    });
  }

  OnClickShowThirdPartyNotice() {
    this.mdDialog.open(NoticesDialogComponent, {
      autoFocus: false,
    });
  }

  openLogoutDialog(event: any) {
    if (event) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        heading: 'Logout',
        body:'Are you sure you want to logout?'
      };
      dialogConfig.width = '40%'
      dialogConfig.autoFocus = false;
      this.mdDialog.open(LogoutDialogComponent, dialogConfig);
    }
  }
}
